import { useEffect, useState } from 'react';

export default function useCalculateIntervalDate( isFull, createDate, currentDate = new Date()) {
    const [value, setValue] = useState();
    const [totalDays, setTotalDays] = useState();
       
    useEffect(() => {
        const dt_date1 = new Date(createDate);
        const dt_date2 = new Date(currentDate);

        //Get the Timestamp
        const date1_time_stamp = dt_date1.getTime();
        const date2_time_stamp = dt_date2.getTime();

        let calc;

        //Check which timestamp is greater
        if (date2_time_stamp > date1_time_stamp) {
            calc = new Date(date2_time_stamp - date1_time_stamp);
        } else {
            calc = new Date(date1_time_stamp - date2_time_stamp);
        }

        //Retrieve the date, month and year
        const calcFormatTmp = calc.getDate() + '-' + (calc.getMonth() + 1) + '-' + calc.getFullYear();
        //Convert to an array and store
        const calcFormat = calcFormatTmp.split("-");
        //Subtract each member of our array from the default date
        const days_passed = Number(Math.abs(calcFormat[0]) - 1);
        const months_passed = Number(Math.abs(calcFormat[1]) - 1);
        const years_passed = Number(Math.abs(calcFormat[2]) - 1970);


        //Set up custom text
        const yrsTxt = ["year", "years"];
        const mnthsTxt = ["month", "months"];
        const daysTxt = ["day", "days"];
        const lessMounth = "Less than 1 month";

        //Convert to days and sum together
        setTotalDays( Math.round((years_passed * 365) + (months_passed * 30.417) + days_passed));
        //display result with custom text
        const result = !isFull
            ? (
                (years_passed == 0 & months_passed == 0 
                                    ? ((days_passed < 31) && lessMounth ) 
                                    : ((years_passed == 1) 
                                        ? years_passed + ' ' + yrsTxt[0] + ' ' 
                                        : (years_passed > 1) 
                                            ? years_passed + ' ' + yrsTxt[1] + ' ' 
                                            : '') + ((months_passed == 1) 
                                                ? months_passed + ' ' + mnthsTxt[0] 
                                                : (months_passed > 1) 
                                                    ? months_passed + ' ' + mnthsTxt[1] + ' ' 
                                                    : '')
                        )) 
                : (
                    ((years_passed == 1) 
                        ? years_passed + ' ' + yrsTxt[0] + ' ' 
                        : (years_passed > 1) 
                            ? years_passed + ' ' + yrsTxt[1] + ' ' 
                            : '') + ((months_passed == 1) 
                                ? months_passed + ' ' + mnthsTxt[0] 
                                : (months_passed > 1) 
                                    ? months_passed + ' ' + mnthsTxt[1] + ' ' 
                                    : '') + ((days_passed == 1) 
                                        ? days_passed + ' ' + daysTxt[0] 
                                        : (days_passed > 1) 
                                            ? days_passed + ' ' + daysTxt[1] 
                                            : '')
                )
        
        setValue(result.trim())
    },[])

  return [value];
}
